<button
  mat-raised-button
  class="basic-button {{ 'button-' + color }} {{ 'button-' + size }} {{
    'button-' + mode
  }} icon-text-button"
  [ngClass]="{
    'button-disabled': disabled,
    'button-shadow': !shadow,
    'icon-text-button--error': hasError,
    'icon-text-button--centered': !!svgIcon && !isLoading
  }"
  [ngStyle]="{ 'height.px': height }"
  [disabled]="disabled"
  matTooltipClass="cm-tooltip typography__tooltip {{ tooltipClass }}"
  matTooltipShowDelay="1500"
  matTooltipHideDelay="500"
  [attr.data-cy]="dataCy ?? 'text-button-with-icon'"
  [matTooltipPosition]="tooltipPosition"
  [matTooltip]="tooltipMessage"
  (click)="handleClick()"
>
  <ng-container *ngIf="!isLoading">
    <mat-icon
      *ngIf="(icon || svgIcon) && iconPosition === 'left'"
      class="material-icons-{{ iconMode }} {{
        'icon-' + size
      }} icon-margin-right"
      [svgIcon]="svgIcon"
      >{{ icon }}</mat-icon
    >
    <span class="{{ 'typography__button-' + size }}">{{ label | translate }}</span>
    <mat-icon
      *ngIf="icon && iconPosition === 'right'"
      class="material-icons-{{ iconMode }} {{
        'icon-' + size
      }} icon-margin-left"
      [svgIcon]="svgIcon"
      >{{ icon }}</mat-icon
    >
  </ng-container>
  <ng-container *ngIf="isLoading">
    <mat-spinner id="fileUploadSpinner" class="primary-spinner" [diameter]="spinnerDiameter"></mat-spinner>
    <span class="{{ 'typography__button-' + size }}">{{ label | translate }}</span>
  </ng-container>
</button>
